import { cdbgAlignment } from "@/lib/proposalData";
import { CheckCircle2, Star } from "lucide-react";

export default function CDBGAlignment() {
  return (
    <section
      id="cdbg-alignment"
      data-testid="section-cdbg-alignment"
      className="bg-[#F9F7F1] py-24 lg:py-32 border-t border-[#CBD5E1]"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-10 mb-14">
          <div className="lg:col-span-6">
            <div className="flex items-center gap-3 mb-3">
              <span className="h-px w-8 bg-[#8B0000]" />
              <span className="font-mono text-[10px] uppercase tracking-[0.28em] text-[#8B0000]">
                Direct Alignment · 2025–2029 Consolidated Plan
              </span>
            </div>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl text-[#0A192F] leading-tight">
              The City named five objectives.<br />
              <em className="italic">Bridge advances all five.</em>
            </h2>
          </div>
          <div className="lg:col-span-6 lg:pt-2 text-[#334155] leading-relaxed">
            <p>
              The City of Baytown's adopted 2025–2029 CDBG Consolidated Plan identifies
              five strategic objectives for federal funding. The Baytown Bridge is not
              a duplicate program — it is the connecting layer that makes the City's
              existing objectives actually reach the residents they were written for.
            </p>
            <p className="mt-3 font-mono text-[10px] uppercase tracking-wider text-[#64748B]">
              Source: City of Baytown 2025–2029 Consolidated Plan Executive Summary
              (24 CFR 91.200(c), 91.220(b)).
            </p>
          </div>
        </div>

        <div className="space-y-px bg-[#CBD5E1] border border-[#CBD5E1]">
          {cdbgAlignment.map((row) => (
            <article
              key={row.id}
              data-testid={`cdbg-row-${row.id}`}
              className={`bg-white grid lg:grid-cols-12 gap-6 p-6 lg:p-8 ${row.primary ? "bg-[#F9F7F1]" : ""}`}
            >
              <div className="lg:col-span-1 flex lg:block items-center gap-3">
                <div className="font-display text-4xl lg:text-5xl text-[#8B0000] leading-none">
                  0{row.id}
                </div>
                {row.primary && (
                  <span
                    className="inline-flex items-center gap-1 font-mono text-[9px] uppercase tracking-widest text-[#8B0000] mt-2"
                    data-testid="cdbg-primary-tag"
                  >
                    <Star className="h-3 w-3 fill-[#D4AF37] text-[#D4AF37]" /> Primary Fit
                  </span>
                )}
              </div>

              <div className="lg:col-span-4">
                <div className="font-mono text-[10px] uppercase tracking-widest text-[#475569] mb-2">
                  City's Stated Objective
                </div>
                <h3 className="font-display text-xl text-[#0A192F] leading-snug">
                  {row.cityObjective}
                </h3>
                <p className="mt-3 text-sm text-[#475569] leading-relaxed">
                  {row.cityNeed}
                </p>
              </div>

              <div className="lg:col-span-7 lg:border-l lg:border-[#CBD5E1] lg:pl-8">
                <div className="font-mono text-[10px] uppercase tracking-widest text-[#8B0000] mb-2">
                  How Baytown Bridge Advances It
                </div>
                <p className="text-[#0A192F] leading-relaxed flex gap-3">
                  <CheckCircle2 className="h-5 w-5 shrink-0 text-[#8B0000] mt-0.5" />
                  <span>{row.bridgeContribution}</span>
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
